import productStickersPdfGenerate2 from './product-stickers-pdf-generate2';
import productStickersPdfGenerate1 from './product-stickers-pdf-generate';
import productStickersPdfGenerate3 from './product-stickers-pdf-generate3';
import productStickersPdfGenerateOutsource from './product-stickers-pdf-generate-outsource';
import { IStickerPdf } from '../../../../services/model/IStickerPdf';

export default async (data: IStickerPdf[], required: string) => {
  const logoType = data[0]?.logoType;
  // 0. Normal  1 .Customer log 2.Without Jadcup log 3. Without made in NZ (Outsource)
  if (logoType === 3) {
    console.log("调用 productStickersPdfGenerateOutsource (logoType 3 - Outsource/Without made in NZ)");
    productStickersPdfGenerateOutsource(data, required);
  } else if (logoType === 0 || logoType === 1 || logoType === 2) {
    console.log("调用 productStickersPdfGenerate3 (logoType 0/1 - Normal/With Customer Logo)");
    productStickersPdfGenerate3(data, required);
  } else {
    console.log("调用 productStickersPdfGenerate1 (other logoType)");
    productStickersPdfGenerate1(data, required);
  }

  console.log("=== product-stickers-pdf-generate_all 完成 ===");
};